import React, { ReactElement } from "react";
import { IconSvg } from "../../icon/icon-svg";

export const IconChat = ({
  color = "#898E97",
  gradient = false,
  ...svgAttrs
}): ReactElement => (
  <IconSvg {...svgAttrs}>
    {gradient && (
      <defs>
        <linearGradient id="grad11" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#eb564f", stopOpacity: 1 }} />
          <stop
            offset="100%"
            style={{ stopColor: "#d73127", stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7376 0.783873C19.6655 0.416973 19.3439 0.152344 18.97 0.152344C18.5961 0.152344 18.2745 0.416973 18.2024 0.783873C17.8357 2.65288 16.3672 4.1315 14.5675 4.49327C14.2023 4.56669 13.9396 4.88755 13.9396 5.2601C13.9396 5.63266 14.2023 5.9535 14.5675 6.02694C16.3676 6.38878 17.8353 7.86528 18.202 9.73385C18.2741 10.1007 18.5957 10.3654 18.9696 10.3654C19.3435 10.3654 19.6651 10.1007 19.7372 9.73385C20.1038 7.86536 21.5719 6.3888 23.3721 6.02694C23.7373 5.9535 24 5.63266 24 5.2601C24 4.88755 23.7373 4.56669 23.3721 4.49327C21.5726 4.13153 20.1044 2.65296 19.7376 0.783873ZM12.82 3.47658C12.3792 3.94671 12.1145 4.57736 12.1145 5.2601C12.1145 6.50195 12.9904 7.57145 14.2078 7.8162C15.2674 8.0292 16.1834 8.9249 16.4112 10.0853C16.6512 11.3084 17.7232 12.1905 18.9696 12.1905C19.7337 12.1905 20.4323 11.8589 20.9138 11.3205V16.8711C20.9138 18.3111 19.7466 19.4783 18.3065 19.4783H10.9858C10.8397 19.4783 10.7003 19.5397 10.6015 19.6473L7.07602 23.4904C6.11176 24.5415 4.35893 23.8592 4.35893 22.4329V19.4783H2.60724C1.1673 19.4783 0 18.3111 0 16.8711V6.08381C0 4.64388 1.1673 3.47658 2.60724 3.47658H12.82Z"
      fill={gradient ? "url(#grad11)" : color}
    />
  </IconSvg>
);
